import React from 'react';
import _ from 'lodash';
import PopoverOfForm from '../../../components/search/FormElements/PopoverOfForm/PopoverOfForm';


export default [
  {
    type: 'document',
    name: 'document_date',
    value: 'Document Filed Date',
    preview: filenameTemplate => _.chain(filenameTemplate.date_format)
      .replace('MM', '06')
      .replace('DD', '28')
      .replace('YYYY', '2018')
      .value(),
    showOnFolderPathEdit: false,
    showOnFileFormatEdit: true,
  },
  {
    type: 'document',
    name: 'document_description',
    value: 'Document Description',
    preview: (filenameTemplate) => {
      // eslint-disable-next-line
      const text = 'Notice of Lodgment of Order with Service filed by Alan Vanderhoff on behalf of SoCal Eats LLC. related documents [370]';
      return text.split(' ').slice(0, filenameTemplate.description_max_words).join(' ');
    },
    tooltip: () => (
      <PopoverOfForm>
        <p>
          Uses &quot;N&quot; number of words from the start of the docket text to describe the document
          (max 20)
        </p>
      </PopoverOfForm>
    ),
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'document',
    name: 'part_description',
    value: 'Part Description',
    preview: () => 'Main Document',
    tooltip: () => (
      <PopoverOfForm>
        <p>
          The generic description assigned by PACER. For example, &quot;main document&quot; or &quot;Exhibit A&quot;
        </p>
      </PopoverOfForm>
    ),
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'document',
    name: 'type',
    value: 'Document Entry Type',
    preview: () => 'DE',
    tooltip: () => (
      <PopoverOfForm>
        <p>
          Will append the letters &quot;DE&quot; or &quot;CE&quot; depending on whether the entry is a docket or claim
        </p>
      </PopoverOfForm>
    ),
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'document',
    name: 'docket_number',
    value: 'Document Entry Number',
    preview: () => '390',
    tooltip: () => (
      <PopoverOfForm>
        <p>This is the docket entry number or proof of claim number</p>
      </PopoverOfForm>
    ),
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  // {
  //   type: 'document',
  //   name: 'document_number',
  //   value: 'Docket Part Number',
  //   preview: () => '1',
  //   tooltip: () => (
  //     <PopoverOfForm>
  //       <p>This is the number assigned by PACER when an entry contain multiple documents</p>
  //     </PopoverOfForm>
  //   ),
  //   showOnFolderPathEdit: true,
  //   showOnFileFormatEdit: true,
  // },
  {
    type: 'case',
    name: 'case_title',
    value: 'Case Title',
    preview: () => 'Lehman Brothers Holdings Inc.',
  },
  {
    type: 'case',
    name: 'case_date',
    value: 'Case Date',
    preview: filenameTemplate => _.chain(filenameTemplate.date_format)
      .replace('MM', '06')
      .replace('DD', '28')
      .replace('YYYY', '2018')
      .value(),
    showOnFolderPathEdit: false,
    showOnFileFormatEdit: true,
  },
  {
    type: 'case',
    name: 'case_number',
    value: 'Case Number',
    preview: () => '1:08-bk-13555',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },

  {
    type: 'court',
    name: 'court_code',
    value: 'Court Code',
    preview: () => 'nysbke',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'court',
    name: 'court_name',
    value: 'Court Name',
    preview: () => 'New York Southern Bankruptcy Court',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'court',
    name: 'court_citation',
    value: 'Court Citation',
    preview: () => 'Bankr.S.D.N.Y.',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'directory_prefix',
    name: 'directory_prefix',
    value: '',
    preview: () => '',
  },
  {
    type: 'separator',
    name: '-',
    value: '-',
    preview: () => '-',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'separator',
    name: '(',
    value: '(',
    preview: () => '(',
    showOnFolderPathEdit: false,
    showOnFileFormatEdit: true,
  },
  {
    type: 'separator',
    name: ')',
    value: ')',
    preview: () => ')',
    showOnFolderPathEdit: false,
    showOnFileFormatEdit: true,
  },
  {
    type: 'separator',
    name: '.',
    value: '.',
    preview: () => '.',
    showOnFolderPathEdit: false,
    showOnFileFormatEdit: true,
  },
  {
    type: 'separator',
    name: '/',
    value: '/',
    preview: () => '/',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: false,
  },
  {
    type: 'separator',
    name: '_',
    value: '_',
    preview: () => '_',
    showOnFolderPathEdit: true,
    showOnFileFormatEdit: true,
  },
  {
    type: 'separator',
    name: ' ',
    value: '[space]',
    preview: () => ' ',
    showOnFolderPathEdit: false,
    showOnFileFormatEdit: true,
  },
];



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/filenameTemplateFields.js